import React from 'react'
import { Modal, Steps, Icon, Button } from 'antd'
import { bankStoSteps, successMessage, errorMessages } from '../../EditSubStoDataPopup/edit-sub-sto.scss'

const { Step } = Steps

export interface Step {
    label: string
    status: 'pending' | 'loading' | 'success' | 'warning' | 'error'
    canRetry?: boolean
    index?: number
    isDoc?: boolean
}

interface Props {
    visible: boolean
    steps: Step[]
    errorMessage?: string
    closable: boolean
    onClose: () => void
    onRetry?: (stepIndex: number) => void
    documentUrl?: string
}

const statusMap: Record<Step['status'], string> = {
    pending: 'wait',
    loading: 'process',
    success: 'finish',
    warning: 'finish',
    error: 'error'
}

const iconMap: Record<Step['status'], React.ReactNode> = {
    pending: <Icon type="clock-circle" />,
    loading: <Icon type="loading" />,
    success: <Icon type="check-circle" theme="filled" style={{ color: '#52c41a' }} />,
    warning: <Icon type="warning" theme="filled" style={{ color: '#faad14' }} />,
    error: <Icon type="close-circle" theme="filled" style={{ color: '#f5222d' }} />
}

const TransactionProgressModal = ({ visible, steps, errorMessage, closable, onClose, onRetry, documentUrl }: Props) => {
    const currentStep = steps.findIndex(s => s.status !== 'success' && s.status !== 'warning')

    const footer = closable ? (
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            {documentUrl && (
                <Button
                    icon="file-text"
                    onClick={() => window.open(documentUrl, '_blank')}
                >
                    פתח מסמך
                </Button>
            )}
            <Button type="primary" onClick={onClose}>סגור</Button>
        </div>
    ) : null

    return (
        <Modal
            visible={visible}
            title="מצב תהליך"
            width={480}
            centered
            maskClosable={false}
            closable={closable}
            onCancel={closable ? onClose : undefined}
            footer={footer}
            style={{ direction: 'rtl' }}
            bodyStyle={{ direction: 'rtl', padding: '16px 24px' }}
        >
            <div className={bankStoSteps}>
                <Steps direction="vertical" size="small" current={currentStep === -1 ? steps.length : currentStep}>
                    {steps.map((step, i) => (
                        <Step
                            key={i}
                            status={statusMap[step.status] as any}
                            icon={iconMap[step.status]}
                            title={
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <span>{step.label}</span>
                                    {step.status === 'error' && step.canRetry && onRetry && (
                                        <Button
                                            type="link"
                                            size="small"
                                            onClick={() => onRetry(step.index!)}
                                            style={{ padding: 0, height: 'auto' }}
                                        >
                                            <Icon type="reload" /> נסה שוב
                                        </Button>
                                    )}
                                </div>
                            }
                        />
                    ))}
                </Steps>
            </div>

            {steps.length > 0 && steps.every(s => s.status === 'success') && (
                <div className={successMessage}>התהליך הושלם בהצלחה ✅</div>
            )}

            {errorMessage && <div className={errorMessages}>{errorMessage}</div>}
        </Modal>
    )
}

export default TransactionProgressModal
